module.exports = __webpack_public_path__ + "img/alva_logo.b7804f30.png";